import axios from 'axios'

/**
 * Clear the wrapper, so we can fill a new resultSet.
 *
 * @param {HTMLElement} wrapper
 */
const clearWrapper = (wrapper) => {
    wrapper.innerHTML = '';
}

/**
 * Append a result item to the result wrapper.
 *
 * @param {HTMLElement} wrapper
 * @param {Object} data
 */
const appendResultItem = (wrapper, data) => {
    const anchor = document.createElement('a');
    anchor.href = data.url;
    anchor.text = data.name;

    const item = document.createElement("li");
    item.appendChild(anchor);
    item.appendChild(document.createTextNode(data.city));
    item.classList.add('result-item');
    wrapper.appendChild(item);
}

/**
 * Execute the search form.
 *
 * @param {Object} element
 */
export default (element) => {
    // Find the elements we need in our section
    const form = document.querySelector('form[data-type="heroServices"]');
    if (!form) {
        return
    }
    const resultsWrapper = form.parentElement.querySelector('.results-wrapper');

    // Listen for the form submit
    form.addEventListener('submit', (event) => {
        event.preventDefault();

        // Post the search data to our office search endpont
        const data = new FormData(form);
        axios.post('/api/default/search-offices-by-services', data)
            .then(function (response) {
                const data = response.data.data;

                // Reset the wrapper
                clearWrapper(resultsWrapper);

                // Populate the result wrapper with our office results
                data.offices.forEach((office) => {
                    appendResultItem(resultsWrapper, office);
                });
            })
            .catch(function (error) {
                console.error(error);
            });
    });
}
